import { ResourceType } from '__types__';
import { ComponentPropsWithoutRef, ComponentRef, forwardRef } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from 'v5/design-system/Select';
import { ResourceTypeIcon } from 'v5/patterns/resource/ResourceTypeIcon';

export type ResourceTypeSelectProps = {
  value?: number;
  onValueChange: (value: number) => void;
  resourceTypes: ResourceType[];
  placeholder?: string;
  disabled?: boolean;
} & Omit<ComponentPropsWithoutRef<typeof SelectTrigger>, 'children'>;

export const ResourceTypeSelect = forwardRef<
  ComponentRef<typeof SelectTrigger>,
  ResourceTypeSelectProps
>(function ResourceTypeSelect(
  {
    value,
    onValueChange,
    resourceTypes,
    placeholder,
    disabled,
    ...triggerProps
  },
  ref
) {
  const hasValue = value != null && value > 0;

  return (
    <Select
      value={hasValue ? String(value) : undefined}
      onValueChange={nextValue => onValueChange(Number(nextValue))}
      disabled={disabled}
    >
      <SelectTrigger ref={ref} {...triggerProps}>
        {!hasValue ? (
          <span
            data-item-text=""
            className="flex! min-w-0 items-center gap-2 truncate"
          >
            <ResourceTypeIcon />
            <SelectValue placeholder={placeholder} />
          </span>
        ) : (
          <SelectValue placeholder={placeholder} />
        )}
      </SelectTrigger>
      <SelectContent>
        {resourceTypes.map(type => (
          <SelectItem key={type.id} value={String(type.id)}>
            <ResourceTypeIcon icon={type.icon} alt="" />
            <span>{type.name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

ResourceTypeSelect.displayName = 'ResourceTypeSelect';
